import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.map";
import _classCallCheck from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/Users/11090604/WorkSpace/dev.vivo.com.cn/vdc2020-pc/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import MyTable from '@/components/MyTable/index.vue';

var Index = /*#__PURE__*/function (_Vue) {
  _inherits(Index, _Vue);

  var _super = _createSuper(Index);

  function Index() {
    var _this;

    _classCallCheck(this, Index);

    _this = _super.apply(this, arguments);
    _this.confIndex = 0; // 主tab

    _this.mainConfIndex = 0; // 次tab

    _this.subConfIndex = 0; // 次tab

    return _this;
  }

  _createClass(Index, [{
    key: "created",
    value: function created() {
      // this.mainConfData = [
      //     ['10:00-10:05', '开场', '主持人', ''],
      //     ['10:05-10:15', '原生万物，致力于联接人与数字世界', '施玉坚', 'vivo高级副总裁'],
      //     ['10:15-11:45', '回归本原：让系统更流畅便捷，让合作更健康开放', '周围', 'vivo副总裁'],
      //     ['11:45-12:15', '生态共赢，打造连接消费者与开发者的桥梁', '李睿', 'vivo互联网战略发展部总经理'],
      // ];
      var mainConfData = [{
        title: '原生万物主会场',
        data: [['10:00-10:05', '开场', '主持人', ''], ['10:05-10:15', '原生万物，致力于联接人与数字世界', '施玉坚', 'vivo高级副总裁'], ['10:15-11:45', '回归本原：让系统更流畅便捷，让合作更健康开放', '周围', 'vivo副总裁'], ['11:45-12:15', '生态共赢，打造连接消费者与开发者的桥梁', '李睿', 'vivo互联网战略发展部总经理']]
      }];
      var subConfData = [{
        title: '应用服务分会场',
        data: [['14:00-14:10', '主持人开场', '', ''], ['14:10-14:40', '能力创新：一站式应用开发服务平台', '刘林', 'vivo开放生态产品总监'], ['14:40-15:10', '应用商店：共享生态，共建价值', '付洲洋', 'vivo应用商店产品总监'], ['15:10-15:25', '应用开发者合作分享', '', ''], ['15:25-15:45', '全球布局，出海共赢', '马良一', 'vivo海外互联网产品中心总监'], ['15:45-15:55', '抽奖互动', '', ''], ['15:55-16:25', '快应用2020：从开发到变现的新探索', '王程恺', 'vivo快应用战略规划经理'], ['16:25-16:55', '技能平台：多模态意图识别，助力服务精准触达', '黄梓勋', 'AI解决方案架构经理'], ['16:55-17:25', '高效分发，精准触达，Jovi服务平台再升级', '张忠琦', 'Jovi服务平台负责人'], ['17:25-17:40', '快应用开发者分享', '', ''], ['17:40-18:00', '颁奖仪式', '', '']]
      }, {
        title: '游戏生态分会场',
        data: [['14:00-14:10', '开场致辞', '郎红星', 'vivo互联网商业运营部总经理'], ['14:10-14:40', '打造全链路优质游戏体验', '曾昆鹏', 'iQOO产品线总经理'], ['14:40-15:10', '共创游戏新世界', '李平恺', 'vivo游戏平台产品总监'], ['15:10-15:40', '平台服务升级，携手孕育爆款产品', '张鹏飞', 'vivo游戏商业运营总监'], ['15:40-15:50', '打破流量焦虑，携手渠道共赢', '邓佩', '完美世界游戏副总裁'], ['15:50-16:00', '抽奖互动', '', ''], ['16:00-16:30', '休闲游戏新生态，IAA乘风破局', '程奕铭', 'vivo游戏平台运营总监'], ['16:30-17:00', '游戏买量，你需要知道的新招式', '李延岗', 'vivo互联网商业产品经理'], ['17:00-18:00', '颁奖仪式', '', '']]
      }, {
        title: '商业合作分会场',
        data: [['14:00-14:30', '聚势新增长 · 洞见新未来', '李利', 'vivo互联网销售中心总经理'], ['14:30-15:00', '聚势谋远 深耕笃行', '洪忠建', 'vivo互联网广告产品总监'], ['15:00-15:40', '聚势突破 激活增长', '赖德意', 'vivo互联网商业运营部商务总监'], ['15:40-15:50', '抽奖互动', '', ''], ['15:55-16:10', '聚势赋能 共赢未来', '杨姗姗', 'vivo互联网广告行业运营总监'], ['16:10-16:25', '聚势通达 扬帆出海', '刘佳', 'vivo海外广告业务商务总监'], ['16:25-16:35', '抽奖互动', '', ''], ['16:35-16:45', '客户分享-知乎', '', ''], ['16:45-17:00', '客户分享-快手', '', '']]
      }, {
        title: '技术开放分会场',
        data: [['14:00-14:10', '主持人开场', '', ''], ['14:10-14:40', '性能加速器-multi-turbo开放', '柯锦玲', '性能优化总监'], ['14:40-15:10', '高效率的开发，高性能的快应用', '王斌', '快应用性能专家'], ['15:10-15:20', '抽奖互动', '', ''], ['15:20-15:50', 'VCAP：端侧推理与训练加速平台能力再升级', '鲁晶', 'VCAP计算加速平台负责人 '], ['15:50-16:10', '搜狗输入法合作分享', '', '']]
      }, {
        title: 'IoT开放生态分会场',
        data: [['14:00-14:10', '主持人开场', '', ''], ['14:10-14:40', 'vivo IoT开放生态平台连接万物', '吴文沧', 'vivo IoT高级技术总监'], ['14:40-15:10', 'vivo IoT开发者平台升级', '胡展鸿', 'vivo  IoT技术经理'], ['15:10-15:30', '美的集团合作分享', '', ''], ['15:30-15:50', '日立楼宇合作分享', '', ''], ['15:50-16:00', '抽奖互动', '', ''], ['16:00-16:30', 'Jovi智能车载平台简介', '夏轶颛', 'vivo车联网平台经理'], ['16:30-16:50', '亿连合作分享', '', ''], ['16:50-17:00', 'CarLife+合作分享', '', '']]
      }];
      this.confData = [mainConfData, subConfData];
      this.maxRows = Math.max.apply(Math, mainConfData.map(function (m) {
        return m.data.length;
      }).concat(subConfData.map(function (s) {
        return s.data.length;
      })));
      this.updateTable();
    }
  }, {
    key: "updateTable",
    value: function updateTable() {
      this.tableData = this.confData[this.confIndex][this.tabIndex].data;
    }
  }, {
    key: "tabChangeHandler",
    value: function tabChangeHandler(index) {
      if (this.confIndex === 0) {
        this.mainConfIndex = index;
      } else {
        this.subConfIndex = index;
      }
    }
  }, {
    key: "tabIndex",
    get: function get() {
      return this.confIndex === 0 ? this.mainConfIndex : this.subConfIndex;
    }
  }]);

  return Index;
}(Vue);

__decorate([Watch('confIndex'), Watch('subConfIndex')], Index.prototype, "updateTable", null);

Index = __decorate([Component({
  name: 'ViewSchedule',
  components: {
    MyTable: MyTable
  }
})], Index);
export default Index;